import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import './ValidatedFail.scss';
import HeaderValidation from '../../Dashboard/Visitor/External/Components/HeaderValidation';
import ContainerValidation from '../../Dashboard/Visitor/External/Components/ContainerValidation';
import BodyValidation from '../../Dashboard/Visitor/External/Components/BodyValidation';
import routes from '../../../Routes/routes';
import {getUrlParameters} from "../../Dashboard/Visitor/External/Model/Model";
import ValidatedFailBody from "../../Dashboard/Visitor/External/ValidatedFailBody";
import {GetInvitationById} from "../../../reduxToolkit/Invitation/InvitationApi";
import {useDispatch} from "react-redux";
import IconLogoIEntry from "../../../assets/images/sklut_horizontal.png"

const ValidatedFail = () => {
    const { id, guardFlowId, eventId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const failedUrl = eventId
        ? getUrlParameters({ url: routes.eventDetails.findMySelf, id: eventId})
        : getUrlParameters({ url: routes.invitationDetails.registrationProcess, id, guardFlowId});

    return (
        <>
            <ContainerValidation>
                <HeaderValidation
                    showBtnBack={false}
                    headerCenter={<img src={IconLogoIEntry} height={100} className={'filter-brightness-85'} alt={"logo"}/>}
                />
                <BodyValidation
                    showBtnNext={false}
                    showBtnPrev={true}
                    showLogoFooter={false}
                    className="identity-invitation-body"
                    classWith="content-center-w-800px gap-2"
                    clickPrev={() => {
                        if(eventId){
                            navigate(failedUrl);
                            return;
                        }
                        dispatch(GetInvitationById(id)).then(({ payload :{data:{ success } }})=>{
                            if (success) {
                                navigate(failedUrl);
                            }
                        });
                    }}
                >
                    <ValidatedFailBody title={"identity_validation_failed"}/>
                </BodyValidation>
            </ContainerValidation>

        </>
    );
};

export default ValidatedFail;
